module.exports = __webpack_public_path__ + "media/assets/images/arrow_left-dbb2542b2fdd1423b61b51b4066cf700.png";